import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Tooltip } from "@material-ui/core";

export default class EditDayDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.day
            ? languages.schedule.editDay
            : languages.schedule.addDay}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <KeyboardDatePicker
              fullWidth
              margin="normal"
              name="date"
              label={languages.createTournament.date}
              format={languages.createTournament.dateFormat}
              cancelLabel={languages.createTournament.cancel}
              autoOk={true}
              value={this.props.date}
              onChange={this.props.handleChange}
              placeholder={languages.createTournament.datePlaceholder}
              invalidLabel={languages.createTournament.invalidDateLabel}
            />
            {(this.props.errorMessage || "").length > 0 && (
              <DialogContentText style={{ color: "red" }}>
                {this.props.errorMessage}
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            {this.props.day && this.props.firstDay ? (
              <Tooltip
                disableFocusListener
                title={languages.structure.firstMatchDayTooltip}
              >
                <div>
                  <Button onClick={this.props.handleDelete} disabled>
                    {languages.general.delete}
                  </Button>
                </div>
              </Tooltip>
            ) : (
              this.props.day && (
                <Button onClick={this.props.handleDelete} color="secondary">
                  {languages.general.delete}
                </Button>
              )
            )}
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.day ? languages.general.save : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
